//
// Copyright (c) 2011-2024 by Curalate, Inc
//

import React, { useState } from 'react';

import { PrimaryLinkButton } from '@components/atoms/button/Button';
import { FilterSection } from '@components/media-filters/filterSectionModels';
import { ContentDrawerTrackingIds } from '@content-drawer/contentDrawerConstants';
import { AllLabelsPanel } from '@content-drawer/filters/labels/AllLabelsPanel';

export interface AllLabelsDialogProps {
  onChange: (section: FilterSection<string>) => void;
  section: FilterSection<string>;
}

export const AllLabelsDialog = ({
  onChange,
  section,
}: AllLabelsDialogProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <PrimaryLinkButton
        onClick={() => setIsOpen(true)}
        trackingId={ContentDrawerTrackingIds.OPEN_ALL_LABELS_MODAL}
      >
        View All
      </PrimaryLinkButton>

      {isOpen && (
        <AllLabelsPanel
          isOpen={isOpen}
          onChange={onChange}
          onClose={() => setIsOpen(false)}
          section={section}
        />
      )}
    </>
  );
};
